export interface DeleteWidgetResponse {
  success: boolean
  data: unknown
}
